/**
 * Fórmula ÚNICA de precios del catálogo, espejo del backend
 * `Product::catalogGrossPrice()` (perronstore-api). Mantener alineada al céntimo
 * para que la card, el carrito y el preview muestren el MISMO precio que cobra el API.
 *
 * Modelo IVA-incluido: el precio mostrado ya incluye IVA y la oferta de catálogo.
 *   grossUnit = round(net × (1 + taxRate/100) × offerFactor)
 *   offerFactor = (onSale && 0 < discountQty < 100) ? (1 − discountQty/100) : 1
 *
 * Un SOLO redondeo (igual que el API). Redondear el IVA y la oferta por separado
 * derivaba ±1 colón de diferencia entre la card y el carrito.
 */
export function grossUnitPrice(
  net: number,
  taxRate: number,
  onSale = false,
  discountQty = 0,
): number {
  const factor =
    onSale && discountQty > 0 && discountQty < 100 ? 1 - discountQty / 100 : 1;
  return Math.round(net * (1 + taxRate / 100) * factor);
}

/** Base imponible (neto) a partir de un bruto con IVA incluido. 2 decimales, como el API. */
export function netFromGross(gross: number, taxRate: number): number {
  return Math.round((gross / (1 + taxRate / 100)) * 100) / 100;
}

/** IVA contenido en un bruto con IVA incluido (resto exacto: net + tax == gross). */
export function taxFromGross(gross: number, taxRate: number): number {
  return gross - netFromGross(gross, taxRate);
}
